import { VImg } from 'vuetify/lib/components/VImg';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert-container pa-4"},[_c(VImg,{attrs:{"src":require(("@/assets/alerts/" + _vm.icon + ".svg")),"min-width":"80","min-height":"80","data-qa":"alert-image"}}),(_vm.$slots.label)?_c('div',{staticClass:"alert-label my-2"},[_vm._t("label")],2):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }